import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { SalesRes } from 'features/sales'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate, useUserRoles } from 'shared/hooks'
import { AuthContext, StoreSettingsContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchSales = () => {
	const { auth } = useContext(AuthContext)
	const axiosPrivate = useAxiosPrivate()
	const query = getCurrentQuery()
	const storeCtx = useContext(StoreSettingsContext)
	const { isUser } = useUserRoles()

	const {
		data: sales,
		isFetching: salesLoading,
		isSuccess: isFetchSalesSuccess
	} = useQuery<SalesRes>({
		queryKey: queryKeys.sales.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.sales(query)),
		enabled: !!auth.accessToken && (isUser || !!storeCtx?.storeSettings?.name)
	})

	return {
		sales,
		salesLoading,
		isFetchSalesSuccess
	}
}
